<template>
  <div>
    <h1 class="text-center mb-2">
      {{ $t('Posts') }}
    </h1>
    <b-row class="blog-list-wrapper align-self-stretch mb-1">

      <b-col
        v-for="blog in posts"
        :key="blog.image"
        md="3"
        class="mb-1"
      >
        <b-card
          tag="article"
          class="h-100"
          no-body
        >
          <b-link :to="{ name: 'post-front-view', params: { id: blog.id } }">
            <b-img
              :src="blog.image"
              class="card-img-top"
            />
          </b-link>
          <b-card-body>
            <b-card-title>
              <b-link
                :to="{ name: 'post-front-view', params: { id: blog.id } }"
                class="blog-title-truncate text-body-heading"
              >
                {{ getTitle(blog) }}
              </b-link>
            </b-card-title>
            <hr>
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center text-body">
                <feather-icon
                  icon="CalendarIcon"
                  class="mr-50"
                />
                <span class="font-weight-bold">{{ new Date(blog.created_at).toISOString().split('T')[0] }}</span>
              </div>
              <b-link
                :to="{ name: 'post-front-view', params: { id: blog.id } }"
                class="font-weight-bold"
              >
                {{ $t('Read more') }}
              </b-link>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import {
  BRow, BCol, BCard, BImg, BLink, BCardTitle, BCardBody,
} from 'bootstrap-vue'

export default {
  name: 'Post',
  components: {
    BRow, BCol, BCard, BImg, BLink, BCardTitle, BCardBody,
  },
  props: {
    posts: {
      required: true,
      type: Array,
    },
  },
  methods: {
    getTitle(post) {
      return post[`title_${this.$i18n.locale}`]
    },
  },
}
</script>

<style scoped>

</style>
